import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategories,
  getInstructors,
  getTypes,
} from "../Redux/LectureCredentialReducer/action";
import { searchLectures } from "../Redux/LectureReducer/action";
import { Paginator, formatTimeSlashFormat } from "../utils";
import { convertDate, convertTimeFormat } from "../Services";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Loader } from "../components/Loader";

const StudentLectures = () => {
  const types = useSelector((state) => state.LectureCredentialReducer.types);
  const categories = useSelector(
    (state) => state.LectureCredentialReducer.categories
  );
  const instructors = useSelector(
    (state) => state.LectureCredentialReducer.instructors
  );
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  const [type, setType] = useState("");
  const [instructor, setInstructor] = useState("");
  const [date, setDate] = useState("");
  const [optional, setOptional] = useState("");
  const allLectures = useSelector((state) => state.LectureReducer.allLectures);
  const loading = useSelector((state) => state.LectureReducer.isLoading);
  const user = useSelector((state) => state.AuthReducer.user);
  const token = useSelector((state) => state.AuthReducer.token);
  const [size, setSize] = useState(1);
  const batchId = user.batchId;
  const sectionId = user.sectionId;
  const name = user.name;
  const role = user.roles[0].name;

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getTypes());
    dispatch(getInstructors());
  }, [])

  const searchData = {
    title: query,
    createdBy: instructor,
    startTime: date ? `${formatTimeSlashFormat(date)} 00:00:00` : "",
    categoryId: category,
    typeId: type,
    optional: optional,
  }

  useEffect(() => {
    const debounceId = setTimeout(() => {
      dispatch(searchLectures(batchId, sectionId, token, searchData));
    }, 700);
    return () => {
      clearTimeout(debounceId);
    }
  }, [query, instructor, date, category, type, optional]);

  const handleResetFilters = () => {
    setCategory("");
    setType("");
    setQuery("");
    setDate("");
    setInstructor("");
    setOptional("");
  };

  const perPageItem = 10;
  const pageNumber = Math.ceil(allLectures.length / perPageItem);
  const pageArray = new Array(pageNumber).fill().map((v, i) => i + 1);
  const { data, total, total_pages, page, per_page } = Paginator(
    allLectures,
    size,
    perPageItem
  );
  const increment = () => {
    if (size < pageArray.length) {
      setSize(size + 1);
    }
  };
  const decrement = () => {
    if (size > 0) {
      setSize(size - 1);
    }
  };
  return (
    <div>
      <Navbar name={name} role={role} />
      <Header title={"Lectures"} role={role} />
      <main>
        <div className="py-12 px-18  bg-[#f3f4f6]">
          <div className="max-w-6xl mx-auto h-auto">
            <div className="grid grid-cols-6 gap-2 p-4  bg-white">
              <div className="col-span-6 h-[70px] text-left">
                <label htmlFor="" className="block text-sm text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  placeholder="search..."
                  value={query}
                  className="px-2 mt-1 h-[35px] border focus:ring-indigo-500 focus-border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>

              <div className="col-span-2 h-[70px] text-left">
                <label htmlFor="" className="block text-sm text-gray-700">
                  Category
                </label>
                <select
                  name=""
                  id=""
                  value={category}
                  className="mt-1 pr-2 block w-full py-2 px-3 capitalize border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value="">Choose</option>
                  {categories.length > 0 &&
                    categories.map((item) => {
                      return (
                        <option key={item.categoryId} value={item.categoryId}>
                          {item.categoryTitle}
                        </option>
                      );
                    })}
                </select>
              </div>

              <div className=" col-span-2 h-[70px] text-left">
                <label htmlFor="" className="block text-sm text-gray-700">
                  Type
                </label>
                <select
                  name=""
                  id=""
                  value={type}
                  className="mt-1 pr-2 block w-full py-2 px-3 capitalize border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value="">Choose</option>
                  {types.length > 0 &&
                    types.map((item) => {
                      return (
                        <option key={item.typeId} value={item.typeId}>
                          {item.typeTitle}
                        </option>
                      );
                    })}
                </select>
              </div>

              <div className=" col-span-2 h-[70px] text-left">
                <label htmlFor="" className="block text-sm text-gray-700">
                  Instructors
                </label>
                <select
                  name=""
                  id=""
                  value={instructor}
                  className="mt-1 pr-2 block w-full py-2 px-3 capitalize border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  onChange={(e) => setInstructor(e.target.value)}
                >
                  <option value="">Choose</option>
                  {instructors.length > 0 &&
                    instructors.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                </select>
              </div>

              <div className=" col-span-2 h-[70px] text-left">
                <label htmlFor="" className="block text-sm text-gray-700">
                  Scheduled
                </label>
                <input
                  type="date"
                  value={date}
                  className="px-2 mt-1 h-[38px] border focus:ring-indigo-500 focus-border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  onChange={(e) => setDate(e.target.value)}
                  pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                />
              </div>

              <div className=" col-span-2 h-[70px] text-left ">
                <label htmlFor="" className="block text-sm text-gray-700">
                  Optional
                </label>
                <select
                  name=""
                  id=""
                  value={optional}
                  className="mt-1 pr-2 block w-full py-2 px-3 capitalize border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  onChange={(e) => setOptional(e.target.value)}
                >
                  <option value="">Choose</option>
                  <option value={false}>No</option>
                  <option value={true}>Yes</option>
                </select>
              </div>
            </div>
            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6 border">
              <button
                onClick={handleResetFilters}
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
              >
                Reset Filters
              </button>
            </div>
            {/* lectures */}
            <div className="flex flex-col">
              <div className="-my-2 overflow-x-auto sm:mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200">
                    {loading ? <Loader /> : ""}
                    <table className="table-fixed mt-2 w-full">
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data.length > 0 &&
                          data.map((item) => {
                            return (
                              <tr
                                className="hover:bg-gray-50"
                                key={item.lectureId}
                              >
                                <td className="px-4 py-5 whitespace-nowrap">
                                  <Link
                                    to={`/lectures/${item.lectureId}`}
                                    title={item.title}
                                  >
                                    <div className="flex items-center text-left">
                                      <div>
                                        <div className="text-xl font-medium text-indigo-600">
                                          <span className="hover:underline">
                                            {item.title}
                                          </span>
                                          <span className="uppercase text-xs ml-2 bg-green-600 text-green-50 p-0.5 rounded px-1">
                                            {item.type}
                                          </span>
                                        </div>
                                        <span className="text-xs pl-[-10px] ">
                                          <strong className="text-gray-800 capitalize">
                                            {item.createdBy}
                                          </strong>
                                          Scheduled{" "}
                                          <strong className="text-gray-800 capitalize">
                                            {item.category}
                                          </strong>{" "}
                                          at{" "}
                                          <span>
                                            {convertDate(item.startTime)}{" "}
                                            {convertTimeFormat(item.startTime)}{" "}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </Link>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right">
                                  <Link
                                    to={`/lectures/${item.lectureId}`}
                                    title={item.title}
                                  >
                                    <span className="inline-flex items-center px-1.5 py-0.5 text-sm font-medium bg-red-500 text-red-100">
                                      Absent
                                    </span>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    {/* pagination */}
                    <div className=" border-t">
                      <div>
                        <nav
                          role="navigation"
                          className="flex items-center justify-between"
                        >
                          <div className="flex items-center justify-between w-full border-t border-gray-200 bg-white px-4 py-5 sm:px-6">
                            <div className="flex flex-1 justify-between sm:hidden">
                              <button
                                onClick={decrement}
                                className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
                              >
                                Previous
                              </button>
                              <button
                                onClick={increment}
                                className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
                              >
                                Next
                              </button>
                            </div>
                            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                              <div>
                                <p className="text-sm text-gray-700">
                                  Showing{" "}
                                  <span className="font-medium">
                                    {data.length > 0 ? page * per_page - per_page + 1 : 0}
                                  </span>{" "}
                                  to{" "}
                                  <span className="font-medium">
                                    {data.length > 0 ? Math.min( page * per_page ,total) : 0}
                                  </span>{" "}
                                  of{" "}
                                  <span className="font-medium">{total}</span>{" "}
                                  results
                                </p>
                              </div>
                              <div>
                                <nav
                                  className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                                  aria-label="Pagination"
                                >
                                  <span className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
                                    <button
                                      className="sr-only cursor-pointer"
                                      onClick={decrement}
                                    >
                                      Previous
                                    </button>
                                    <ChevronLeftIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                      onClick={decrement}
                                    />
                                  </span>
                                  {pageArray.length > 0 &&
                                    pageArray.map((item, i) => {
                                      if (item <= 10) {
                                        return (
                                          <button
                                            key={i}
                                            onClick={() => setSize(item)}
                                            className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset active:bg-blue-800 active:text-white ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 cursor-pointer"
                                          >
                                            {item}
                                          </button>
                                        );
                                      }
                                    })}

                                  <span className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
                                    <span
                                      className="sr-only"
                                      onClick={increment}
                                    >
                                      Next
                                    </span>
                                    <ChevronRightIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                      onClick={increment}
                                    />
                                  </span>
                                </nav>
                              </div>
                            </div>
                          </div>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default StudentLectures;
